export const ResponseCode = {
    E_INVALID_TOKEN: 'E_INVALID_TOKEN',
};
